import React, { Fragment } from 'react';

import CurrentUserRankButtons from 'buyside/components/presentation/RankingsIndexPage/currentUserRankInfo/CurrentUserRankButtons';
import CurrentUserRankCard from 'buyside/components/presentation/RankingsIndexPage/currentUserRankInfo/currentUserRankCard';

const CurrentUserRankInfo = ({ currentRanks, currentUserRank, isMobile, category }) => {
  return (
    <Fragment>
      {currentUserRank && (
        <CurrentUserRankCard
          category={category}
          currentRank={currentUserRank}
          rankingCreatedDate={currentUserRank.createdAt}
        />
      )}
      <CurrentUserRankButtons currentRanks={currentRanks} category={category} isMobile={isMobile} />
      {(currentUserRank || currentRanks) && <hr />}
    </Fragment>
  );
};

export default CurrentUserRankInfo;
